import axios, { AxiosError } from "axios";
// Dev
// const axiosInstance = axios.create({
//     baseURL: 'https://dev.pingle.in/dev_Ragul_test/',
//     headers: {
//         "Access-Control-Allow-Origin": "*"
//     },
// });

//  AWS Dev
// const axiosInstance = axios.create({
//     baseURL: 'https://dev-aws.pingle.in/api/',
//     headers: {
//         "Access-Control-Allow-Origin": "*"
//     },
// });

// Test API
// const axiosInstance = axios.create({
//     baseURL: 'https://pingle.in/test/api/',
//     headers: {
//         "Access-Control-Allow-Origin": "*"
//     },
// });


// Pre Production API
// const axiosInstance = axios.create({
//     baseURL: 'https://pingle.in/pre-production/api/',
//     headers: { "Access-Control-Allow-Origin": "*" },
// });

// Production API 
const axiosInstance = axios.create({
    baseURL: 'https://pingle.in/api/',
    headers: {
        "Access-Control-Allow-Origin": "*"
    },
});

axiosInstance.interceptors.request.use(
    async (config) => {
        const user = JSON.parse(localStorage.getItem("user"));

        const paramtoken = user?.token;
        if (paramtoken) {
            if (config.headers)
                (config.headers).set("Authorization-Token", `${paramtoken}`);
        }
        return config;
    },
    (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error instanceof AxiosError && error.response?.status === 401) {
            // useAuthStore.setState({ signedInAs: undefined });
        }
        return Promise.reject(error);
    },
);

// NodeaxiosInstance.interceptors.request.use(
//     async (config) => {
//         const token = localStorage.getItem("token");
//         if (token) {
//             if (config.headers)
//                 (config.headers).set("Authorization", `${token}`);
//         }
//         return config;
//     },
//     (error) => Promise.reject(error),
// );

// NodeaxiosInstance.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error instanceof AxiosError && error.response?.status === 401) {
//             // useAuthStore.setState({ signedInAs: undefined });
//         }
//         return Promise.reject(error);
//     },
// );




export default axiosInstance;

export const Razorpay_Key = process.env.REACT_APP_LIVE_RAZORPAY_KEY;
export const environment = "PRODUCTION"; //PRODUCTION (or) TEST (or) DEVELOPMENT
export const baseURL = "https://web.pingle.in/"; //PRODUCTION (or) TEST (or) DEVELOPMENT


